import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import CodeOutlinedIcon from '@mui/icons-material/CodeOutlined';
import DeveloperModeOutlinedIcon from '@mui/icons-material/DeveloperModeOutlined';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
// import LocalActivityIcon from '@mui/icons-material/LocalActivity';
import {
	Chip,
	Dialog,
	// DialogContent,
	DialogTitle,
	IconButton,
	Snackbar,
	Stack,
} from '@mui/material';
// import { ImageCarousel } from 'components';
import Ownershipcard from 'components/Product/Ownershipcard';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useUserInfo } from 'stores';
import { dynamicObjectType } from 'types';

interface ProductChipGroupProps {
	currentReqUAID: string;
	batchNumber: string;
	uaidType: number;
	status: string;
	scanCount: number;
	firstVerifySDatetimeInt: number;
	hiddenProductInfoList: Array<dynamicObjectType>;
}

const ProductChipGroup = (props: ProductChipGroupProps) => {
	const { t } = useTranslation();
	const [openOSC, setOpenOSC] = useState(false); //status for ownership card dialog
	const [batchNum, setBatchNum] = useState(false); //status for copy batch number
	const [UAID, setUAID] = useState(false); //status for copy uaid 12-characters
	// const [openCoupon, setOpenCoupon] = useState(false); //status for coupon

	const user = useUserInfo(); //check whether is log in
	const {
		currentReqUAID,
		batchNumber,
		uaidType,
		status,
		scanCount,
		firstVerifySDatetimeInt,
		// hiddenProductInfoList,
	} = props;

	const handleCloseOSC = () => {
		setOpenOSC(false);
	};

	const toOpenOwnershipCard = () => {
		setOpenOSC(true);
	};

	// const handleCloseCoupon = () => {
	// 	setOpenCoupon(false);
	// };

	// const toOpenCoupon = () => {
	// 	setOpenCoupon(true);
	// };

	const clickToCopyUAID = () => {
		setUAID(true);
		navigator.clipboard.writeText(currentReqUAID);
	};

	const clickToCopyBatch = () => {
		setBatchNum(true);
		navigator.clipboard.writeText(batchNumber);
	};

	useEffect(() => {
		const now = new Date().getTime();
		if (scanCount === 1 && now - firstVerifySDatetimeInt <= 5000) { //trying to achive only first time authenticate success will auoto popup ownershipcard,
			setOpenOSC(true);                                           //but maybe not the best way, since it may affected by network
		}
	}, []);

	return (
		<>
			<Stack direction="row" spacing={2} pl={2} pr={2} pt={1}>
				<Chip
					icon={
						<CodeOutlinedIcon
							sx={{
								color: (theme) =>
									`${theme.palette.productChips?.icon} !important`,
							}}
						/>
					}
					size="small"
					//label="QR0000001"
					label={currentReqUAID}
					onClick={clickToCopyUAID}
					sx={{
						color: 'productChips.text',
						backgroundColor: 'productChips.main',
					}}
				/>
				<Snackbar
					open={UAID}
					onClose={() => setUAID(false)}
					autoHideDuration={3000}
					message={t('product.copyUAIDToClipboard')}
				/>
				<Chip
					icon={
						<DeveloperModeOutlinedIcon
							sx={{
								color: (theme) =>
									`${theme.palette.productChips?.icon} !important`,
							}}
						/>
					}
					size="small"
					//label="AB123412-4"
					label={batchNumber}
					onClick={clickToCopyBatch}
					sx={{
						color: 'productChips.text',
						backgroundColor: 'productChips.main',
					}}
				/>
				<Snackbar
					open={batchNum}
					onClose={() => setBatchNum(false)}
					autoHideDuration={3000}
					message={t('product.copyBatchNoToClipboard')}
				/>
				{status && status === 'success' && !user && uaidType !== 7 && (
					<>
						<Chip
							icon={
								<CloudDownloadIcon
									sx={{
										color: (theme) =>
											`${theme.palette.productChips?.icon} !important`,
									}}
								/>
							}
							size="small"
							label={t('ownershipCard.download')}
							onClick={toOpenOwnershipCard}
							sx={{
								color: 'productChips.text',
								backgroundColor: 'productChips.main',
							}}
						/>
						<Dialog
							open={openOSC}
							onClose={handleCloseOSC}
							aria-describedby="alert-dialog-slide-description"
						>
							<DialogTitle>
								<IconButton
									aria-label="close"
									onClick={handleCloseOSC}
									sx={{
										position: 'absolute',
										right: 8,
										top: 8,
										color: 'primary.main',
									}}
								>
									<HighlightOffIcon />
								</IconButton>
							</DialogTitle>
							<div>
								<Ownershipcard
									requestedUAID={currentReqUAID}
								></Ownershipcard>
							</div>
						</Dialog>
					</>
				)}

				{/* {uaidType === 2 &&
					hiddenProductInfoList &&
					hiddenProductInfoList.length !== 0 && (
						<>
							<Chip
								icon={<LocalActivityIcon />}
								size="small"
								label={t('product.coupon')}
								onClick={toOpenCoupon}
							/>
							<Dialog
								open={openCoupon}
								onClose={handleCloseCoupon}
								aria-describedby="alert-dialog-slide-description"
							>
								<DialogTitle>
									{t('product.coupon')}
									<IconButton
										aria-label="close"
										onClick={handleCloseCoupon}
										sx={{
											position: 'absolute',
											right: 8,
											top: 8,
											color: 'primary.main',
										}}
									>
										<HighlightOffIcon />
									</IconButton>
								</DialogTitle>
								<DialogContent>
									<ImageCarousel
										obejctsContainImage={
											hiddenProductInfoList
										}
									/>
								</DialogContent>
							</Dialog>
						</>
					)} */}
			</Stack>
		</>
	);
};

export default ProductChipGroup;
